import React from "react";

import {
  Button,
  Collapse,
  Card
} from "@blueprintjs/core";
import { Trans } from "react-i18next";
import i18n from '../../i18n';
import i18next from 'i18next';
import { mefMontantStr } from "../../utils/mef";
import { TableCustom } from "../Structure/navbar/blueprintTableincludes";

export default class UserHistory extends React.Component {

  constructor() {
    super();
    this.state = {
      isOpen: false,
      activity: []
    }
  }

  handleOpen = () => this.setState({ isOpen: true });

  handleClose = () => this.setState({
    isOpen: false,
    activity: []
  });

  render() {
    return (
      <div>
        <Button icon={this.state.isOpen ? "cross" : "history"} onClick={this.state.isOpen ? this.handleClose : this.handleOpen} text={i18n.t(this.state.isOpen ? "hide" : "show") + " " + i18n.t("user history")} />
        <Collapse onClose={this.handleClose} isOpen={this.state.isOpen} style={{ transition: 'none' }}>
          <Card>
            <TableCustom
              paging={true}
              url={"/user/activity"}
              orderBy="date"
              columns={[
                {
                  title: "Date",
                  field: "date",
                  sortable: true,
                  render: raw => { return new Date(raw.date).toLocaleString(i18next.language) }
                },
                {
                  title: <Trans>user</Trans>,
                  field: "user",
                  sortable: true,
                  render: raw => raw?.user?.login || raw.api.name
                },
                {
                  title: <Trans>activity</Trans>,
                  field: "type",
                  sortable: true,
                  render: raw => <Trans>{"activityType" + raw.type}</Trans>,
                  /*  lookup: {
                     0: i18n.t("activityType"+0),
                     1: i18n.t("activityType"+1),
                     2: i18n.t("activityType"+2),
                     3: i18n.t("activityType"+3),
                     4: i18n.t("activityType"+4),
                     5: i18n.t("activityType"+5),
                     6: i18n.t("activityType"+6)
                   },
                   filtering: true */
                },
                {
                  title: <Trans>equipment</Trans>,
                  field: "equipment",
                  sortable: true,
                  render: raw => raw.equipment == null ? '-' : raw.equipment
                },
                {
                  title: <Trans>park</Trans>,
                  field: "park",
                  sortable: true,
                  render: raw => raw.park == null ? '-' : raw.park
                },
                {
                  title: <Trans>amount</Trans>,
                  field: "amount",
                  sortable: true,
                  render: raw => raw.amount == null ? null : mefMontantStr(raw.amount)
                },
                {
                  title: <Trans>Justification</Trans>,
                  field: "justification",
                  sortable: false,
                  render: raw => raw.justification == null ? '-' : raw.justification
                }
              ]}
            />
          </Card>
        </Collapse >
      </div>
    )
  }
}